module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "customer_form"
    }
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.alertStatus),
      callback: function($$v) {
        _vm.alertStatus = $$v
      },
      expression: "alertStatus"
    }
  }, [_vm._v("We have recieved your tax exemption. Upon verification your status will be updated.")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "counter": 20,
      "error-messages": _vm.errors.collect('fname'),
      "data-vv-name": "fname",
      "required": "",
      "label": "First Name"
    },
    model: {
      value: (_vm.data.fName),
      callback: function($$v) {
        _vm.$set(_vm.data, "fName", $$v)
      },
      expression: "data.fName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "append-icon": "edit",
      "counter": 20,
      "error-messages": _vm.errors.collect('lname'),
      "data-vv-name": "lname",
      "required": "",
      "label": "Last Name"
    },
    model: {
      value: (_vm.data.lName),
      callback: function($$v) {
        _vm.$set(_vm.data, "lName", $$v)
      },
      expression: "data.lName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "append-icon": "email",
      "error-messages": _vm.errors.collect('email'),
      "label": "Email",
      "data-vv-name": "email",
      "required": ""
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "issue",
    attrs: {
      "items": _vm.issueList,
      "label": "Issue",
      "item-text": "name",
      "item-value": "name",
      "data-vv-name": "issue",
      "require": ""
    },
    on: {
      "click:append": _vm.closeIssue
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.name))]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.data.issue),
      callback: function($$v) {
        _vm.$set(_vm.data, "issue", $$v)
      },
      expression: "data.issue"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "d-flex": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:20'),
      expression: "'required|min:20'"
    }],
    attrs: {
      "name": "input-3-1",
      "label": "What's wrong?",
      "error-messages": _vm.errors.collect('description'),
      "data-vv-name": "description",
      "required": ""
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "enter",
    attrs: {
      "items": _vm.enterList,
      "label": "Entered By",
      "hint": "employee entering the ticket",
      "data-vv-name": "enter",
      "require": "",
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "click:append": _vm.closeEnter
    },
    model: {
      value: (_vm.data.enter),
      callback: function($$v) {
        _vm.$set(_vm.data, "enter", $$v)
      },
      expression: "data.enter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('vue-uppy-cloudinary', {
    attrs: {
      "preset": "reqe2pqu",
      "cloudName": "kencove",
      "allowedFileTypes": _vm.allowedFileTypes
    },
    on: {
      "uploaded": _vm.uploaded
    }
  })], 1), _vm._v(" "), (_vm.attachments.length != 0) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('h3', [_vm._v("Upload Files:")]), _vm._v(" "), _vm._l((_vm.attachments), function(item) {
    return _c('ul', {
      key: item.etag
    }, [_c('li', [_vm._v(_vm._s(item.original_filename))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-btn', {
    staticClass: "submit",
    on: {
      "click": _vm.submitForm4
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c1fed97!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer_interaction_form.vue
// module id = 95
// module chunks = 2